import { z } from "zod";
import { blockedRangeSchema } from "./blocked-range.js";
export const availabilityResponseSchema = z.object({
    slug: z.string().min(1),
    currency: z.string().min(1),
    minNights: z.number().int().positive(),
    widgetEnabled: z.boolean(),
    blockedRanges: z.array(blockedRangeSchema),
});
